import React from 'react'
import UserHospital from '../../components/UserHospital/UserHospital'

function UserHospitalPage() {
  return (
    <UserHospital/>
  )
}

export default UserHospitalPage